import DlContainer from "./container"
import DlBreadcrumb from "./breadcrumb"
import DlPageHeader from "./pageHeader"
import DlTableResult from "./tableResult"
import DlTableResultCol from "./tableResultCol"

export default {
  DlContainer,
  DlBreadcrumb,
  DlPageHeader,
  DlTableResult,
  DlTableResultCol
}
